export default __webpack_public_path__ + "assets/sync-menu.1ea06467.svg";